// import React from "react";
// import { FaArrowRight } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBuildingShield } from "@fortawesome/free-solid-svg-icons";
// import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
// import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
// import { faUserTie } from "@fortawesome/free-solid-svg-icons";
// import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
// import { faSignal } from "@fortawesome/free-solid-svg-icons";
// const ThirdCard = () => {
//   return (
//     <>
//       <div className="px-2 py-10 lg:py-20 font-Questrial">
//         <div id="features" className="mx-auto max-w-6xl">
//           <div className="text-center px-4 lg:px-6  ">
//             <h2 className="text-4xl lg:text-4xl font-semibold mb-2 mt-6 font-Calistoga">
//               <span className="text-blue-700">Certified Engineers</span> On Your
//               fingertips. Tailored Solutions That Benefit You <br />{" "}
//               {/* <span className="text-blue-700">Transform,</span>{" "}
//               <span className="bg-gradient-to-r from-blue-700 to-purple-600 bg-clip-text text-transparent">
//                 Scale,
//               </span>{" "}
//               <span className="bg-gradient-to-r from-blue-700 to-pink-600 bg-clip-text text-transparent">
//                 Optimize
//               </span>{" "} */}
//             </h2>
//           </div>
//           <ul className="mt-16 grid grid-cols-1 gap-6 lg:gap-10 text-center text-slate-700 md:grid-cols-3">
//             <li className="rounded-xl bg-white px-6 py-8 shadow-lg transition-colors duration-300 hover:bg-blue-900 hover:text-white">
//               <FontAwesomeIcon
//                 icon={faThumbsUp}
//                 className="mx-auto h-12 w-12 text-blue-500 transition-colors duration-300 hover:text-white"
//               />
//               <h3 className="my-3 font-display font-bold">Salary Arbitrage</h3>
//               <p className="mt-1.5 text-xs leading-6 text-green-400">
//                 30% to 50% saving
//               </p>
//               <p className="mt-1.5 text-sm leading-6">
//                 {/* You Pay Employee Salary, Not Vendor Pricing. */}
//                 You Pay Employee Salary, Not Vendor Pricing or Service Costs.
//               </p>
//             </li>
//             <li className="rounded-xl bg-white px-6 py-8 shadow-lg transition-colors duration-300 hover:bg-blue-900 hover:text-white">
//               <FontAwesomeIcon
//                 icon={faBuildingShield}
//                 className="mx-auto h-12 w-12 text-blue-500 transition-colors duration-300 hover:text-white"
//               />
//               <h3 className="my-3 font-display font-bold">Infrastructure</h3>
//               <p className="mt-1.5 text-xs leading-6 text-green-400">
//                 100% saving
//               </p>
//               <p className="mt-1.5 text-sm leading-6">
//                 No Bills For Rent Equipment, Security And Maintenance.
//               </p>
//             </li>
//             <li className="rounded-xl bg-white px-6 py-8 shadow-lg transition-colors duration-300 hover:bg-blue-900 hover:text-white">
//               <FontAwesomeIcon
//                 icon={faUserPlus}
//                 className="mx-auto h-12 w-12 text-blue-500 transition-colors duration-300 hover:text-white"
//               />
//               <h3 className="my-3 font-display font-bold">Recruitment</h3>
//               <p className="mt-1.5 text-xs leading-6 text-green-400">
//                 100% saving
//               </p>
//               <p className="mt-1.5 text-sm leading-6">
//                 Quick Hiring Abd On-boarding With A World Class Procress.
//               </p>
//             </li>
//             <li className="rounded-xl bg-white px-6 py-8 shadow-lg transition-colors duration-300 hover:bg-blue-900 hover:text-white">
//               <FontAwesomeIcon
//                 icon={faUserTie}
//                 className="mx-auto h-12 w-12 text-blue-500 transition-colors duration-300 hover:text-white"
//               />
//               <h3 className="my-3 font-display font-bold">
//                 Managed HR & Admin
//               </h3>
//               <p className="mt-1.5 text-xs leading-6 text-green-400">
//                 100% efforts saving
//               </p>
//               <p className="mt-1.5 text-sm leading-6">
//                 Effort-free HR And Office Management - Payroll, Attendance,
//                 Compliance.
//               </p>
//             </li>
//             <li className="rounded-xl bg-white px-6 py-8 shadow-lg transition-colors duration-300 hover:bg-blue-900 hover:text-white">
//               <FontAwesomeIcon
//                 icon={faUserGroup}
//                 className="mx-auto h-12 w-12 text-blue-500 transition-colors duration-300 hover:text-white"
//               />
//               <h3 className="my-3 font-display font-bold">
//                 Minimize Attrition
//               </h3>
//               <p className="mt-1.5 text-xs leading-6 text-green-400">
//                 100% efforts saving
//               </p>
//               <p className="mt-1.5 text-sm leading-6">
//                 Attrition Is Expensive. So Minimize It With Employees That Align
//                 With Your Mission/Vision
//               </p>
//             </li>
//             <li className="rounded-xl bg-white px-6 py-8 shadow-lg transition-colors duration-300 hover:bg-blue-900 hover:text-white">
//               <FontAwesomeIcon
//                 icon={faSignal}
//                 className="mx-auto h-12 w-12 text-blue-500 transition-colors duration-300 hover:text-white"
//               />
//               <h3 className="my-3 font-display font-bold">
//                 On-demand Scalability
//               </h3>
//               <p className="mt-1.5 text-xs leading-6 text-green-400">
//                 100% efforts saving
//               </p>
//               <p className="mt-1.5 text-sm leading-6">
//                 Stars As Small As You Like, Expand As Fast As You Need.
//               </p>
//               {/* <Link
//                 to="/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="mt-2 flex items-center justify-center text-blue-700 transition-colors duration-300 hover:text-white"
//               >
//                 Read More
//                 <FaArrowRight className="ml-2 arrow transition-transform duration-300 group-hover:translate-x-1" />
//               </Link> */}
//             </li>
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ThirdCard;

import React from "react";
import {
  FaHandHoldingDollar,
  FaBuildingShield,
  FaUserPlus,
  FaUserTie,
  FaMinimize,
} from "react-icons/fa6";
import { FaExpandArrowsAlt } from "react-icons/fa";
const features = [
  {
    title: "Salary Arbitrage",
    highlight: "30% to 50% saving",
    description:
      "You Pay Employee Salary, Not Vendor Pricing or Service Costs.",
    icon: (
      <FaHandHoldingDollar className="mx-auto h-12 w-12 text-[#5c68f2] group-hover:text-white" />
    ),
  },
  {
    title: "Infrastructure",
    highlight: "100% saving",
    description: "No Bills For Rent Equipment, Security And Maintenance.",
    icon: (
      <FaBuildingShield className="mx-auto h-12 w-12 text-[#5c68f2] group-hover:text-white" />
    ),
  },
  {
    title: "Recruitment",
    highlight: "100% saving",
    description: "Quick Hiring And On-boarding With A World Class Process.",
    icon: (
      <FaUserPlus className="mx-auto h-12 w-12 text-[#5c68f2] group-hover:text-white" />
    ),
  },
  {
    title: "Managed HR & Admin",
    highlight: "100% efforts saving",
    description:
      "Effort-free HR And Office Management - Payroll, Attendance, Compliance.",
    icon: (
      <FaUserTie className="mx-auto h-12 w-12 text-[#5c68f2] group-hover:text-white" />
    ),
  },
  {
    title: "Minimize Attrition",
    highlight: "100% efforts saving",
    description:
      "Attrition Is Expensive. So Minimize It With Employees That Align With Your Mission/Vision.",
    icon: (
      <FaMinimize className="mx-auto h-12 w-12 text-[#5c68f2] group-hover:text-white" />
    ),
  },
  {
    title: "On-demand Scalability",
    highlight: "100% efforts saving",
    description: "Start As Small As You Like, Expand As Fast As You Need.",
    icon: <FaExpandArrowsAlt className="mx-auto h-12 w-12 text-[#5c68f2] group-hover:text-white" />,
  },
];

const FeatureCard = ({ icon, highlight, title, description }) => (
  <li className="group rounded-xl bg-white px-4 py-6 shadow-lg transition-transform duration-300 hover:scale-110 hover:bg-[#5c68f2] hover:text-white">
    {icon}
    <p className="mt-1.5 text-sm leading-4 bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent group-hover:text-white">
      {highlight}
    </p>
    <h3 className="my-1 font-display text-md font-semibold group-hover:text-white">
      {title}
    </h3>
    <p className="mt-1.5 text-xs leading-4 group-hover:text-white">
      {description}
    </p>
  </li>
);

const ThirdCard = () => {
  return (
    <section className="px-2 py-10 lg:py-20 font-Questrial ">
      <div id="features" className="mx-auto max-w-4xl">
        <div className="text-center px-4 lg:px-6 leading-10">
          <h2 className="heading-animation text-3xl lg:text-[30px] font-medium mb-2 mt-6 font-Calistoga text-slate-600 leading-relaxed">
            <span className="bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent">
              Certified Engineers
            </span>{" "}
            On Your Fingertips. <br /> Tailored Solutions That Benefit You
          </h2>
        </div>
        <ul className="mt-16 grid grid-cols-1 gap-6 lg:gap-10 text-center md:grid-cols-3 md:px-6">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ThirdCard;
